import React, { Component } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-regular-svg-icons';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import favorite from '../util/favorite';

class CompareButton extends Component {
    handleCompare = (event) => {
        if (event) event.preventDefault(); // prevent form submission

        this.props.history.push(this.props.to);
        this.props.onClickAway();

        return false;
    }

    render() {
        return <Tooltip title="Add Character for Comparison" placement="left"><button className="btn btn-primary btn-sm" onClick={this.handleCompare}><FontAwesomeIcon icon={faPlus} /></button></Tooltip>;
    }
}

export default class FavoriteDown extends Component {
    compareUrl() {
        if (!window.bootstrap.md.matches) return null;

        const parts = document.location.pathname.split('/');
        if (parts[0]) return null; // shouldn't happen
        if (parts[1] !== 'characters') return null;
        return '/characters/' + parts[2] + '/' + parts[3] + '/' + parts[4] + '/compare/';
    }

    render() {
        const rows = [];
        const favorites = favorite.get('favorites').getFavorites();
        const compareUrl = this.compareUrl();

        for (let i = 0; i < 5 && i < favorites.length; i++) {
            const character = favorites[i];
            const link = '/characters/' + encodeURIComponent(character.region) + '/' + encodeURIComponent(character.realm) + '/' + encodeURIComponent(character.character);
            const link2 = compareUrl + encodeURIComponent(character.region) + '/' + encodeURIComponent(character.realm) + '/' + encodeURIComponent(character.character);

            rows.push(
                <tr key={'row' + i}>
                    <td className="align-middle p-2 my-auto" width="1%">
                        {character.thumbnail ?
                            <Link to={link} onClick={this.props.onClickAway}>
                                <img className="rounded" style={{width:'2em',height:'2em'}} src={'https://render.worldofwarcraft.com/' + character.region.toLowerCase() + '/character/' + character.thumbnail} alt="Avatar" />
                            </Link>
                        : null}
                    </td>
                    <td className="align-middle p-0 pr-5 my-auto">
                        <div><Link className={'class-' + character.class} to={link} onClick={this.props.onClickAway}>{character.character}</Link></div>
                        <div className="small">{character.region.toUpperCase()}-{character.realm}</div>
                    </td>
                    {compareUrl ? <td width="1%" className="align-middle px-2 py-0"><CompareButton history={this.props.history} to={link2} onClickAway={this.props.onClickAway} /></td> : null}
                </tr>
            );
        }

        if (!rows.length) {
            rows.push(
                <tr key="empty">
                    <td className="small">Please choose your favorite characters by clicking the <FontAwesomeIcon icon={faStar} /> button on their profile.</td>
                </tr>
            )
        }

        return (
            <div className="card">
                <div className="card-header p-2 text-center">
                    <Link to="/favorites" onClick={this.props.onClickAway}>Favorites</Link>
                </div>
                <table className="table m-0"><tbody>{rows}</tbody></table>
                <div className="card-footer p-2 text-center">
                    <Link to="/favorites" onClick={this.props.onClickAway}>More...</Link>
                </div>
            </div>
        );
    }
}